// extracted by mini-css-extract-plugin
module.exports = {"root":"root-26Fsh","button":"button-1PQkr"};